var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.inputComponent,_vm._b({tag:"component",attrs:{"value":_vm.$attrs.value,"type":_vm.inputType},on:{"input":_vm.emitValue}},'component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }